<!--
  Airwallex支付

  import Airwallex from '@/components/Airwallex.vue'
  <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFail" @cancel="payCancel" />
-->
<template>
  <div>
    <el-dialog :title="$t('Components.Airwallex.Airwallex')" append-to-body :visible.sync="visible" :width="isPC ? '40%' : '100%'" destroy-on-close :close-on-click-modal="false" @close="dialogCloseCb">
      <div id="dropIn" v-loading="loading" style="min-height: 150px;"></div>
    </el-dialog>
    <div></div>
  </div>
</template>

<script>
// import axios from 'axios'
import API from '@/api'
import _ from 'lodash'
import { loadScript } from '@/util/index'
loadScript('https://checkout.airwallex.com/assets/elements.bundle.min.js')

export default {
  props: {
    // 支付成功回调页面（绝对路径）
    payCallbackUrl: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      paymentId: '',
      status: '',
      timer: null,
      callNumber: 0,
      components: ['card', 'wechatpay', 'alipaycn'], // Airwallex 支付方式
      payLoading: null
    }
  },
  methods: {
    show(paymentId, components) {
      /**
       * -----
       * 停用kaka微信支付方式
       * 2023.3.1
       */
      let i = components.indexOf('wechatpay')
      if (i > -1) {
        components.splice(i, 1)
      }
      // ----

      this.components = components
      this.paymentId = paymentId
      this.visible = this.loading = true
      this.$nextTick(() => this.getAirwallexPaymentIntent(paymentId))
    },
    close() {
      this.paymentId = ''
      this.status = ''
      this.visible = false
    },
    dialogCloseCb() {
      this.status === '' && this.$emit('cancel')
      this.status = ''
    },
    /**
     * 初始化支付插件
     */
    airwallexInit(intent_id, client_secret, currency) {
      // STEP #2: Initialize the Airwallex global context for event communication
      window.Airwallex.init({
        env: process.env.NODE_ENV === 'production' ? 'prod' : 'demo', // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
        origin: window.location.origin // Setup your event target to receive the browser events message
      })

      // STEP #4: Create 'dropIn' element
      const dropIn = window.Airwallex.createElement('dropIn', {
        // Required, dropIn use intent Id, client_secret and currency to prepare checkout
        intent_id,
        client_secret,
        currency,
        components: this.components
      })
      // STEP #5: Mount 'dropIn' element
      dropIn.mount('dropIn') // This 'dropIn' id MUST MATCH the id on your empty container created in Step 3

      // STEP #7: Add an event listener to handle events when the payment is successful.
      window.addEventListener('onSuccess', this.paySuccess)
      // STEP #8: Add an event listener to handle events when the payment has failed.
      window.addEventListener('onError', this.payFail)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('onSuccess', this.paySuccess)
        window.removeEventListener('onError', this.payFail)
      })
      this.loading = false
    },
    /**
     * 获取支付所需要的参数
     */
    getAirwallexPaymentIntent(paymentId) {
      API.getAirwallexPaymentIntent(paymentId, { returnUrl: this.payCallbackUrl }).then(result => {
        const { id, clientSecret, currency } = result.data
        this.airwallexInit(id, clientSecret, currency)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.loading = false
        this.close()
      })
    },
    /**
     * 支付成功回调
     */
    paySuccess: _.debounce(function(event) {
      this.getOrderState(this.paymentId)
    }, 1000, { leading: true, trailing: false }),
    /**
     * 支付失败回调
     */
    payFail: _.debounce(function(event) {
      this.status = 'fail'
      this.close()
      this.$emit('fail', event.detail.error)
    }, 1000, { leading: true, trailing: false }),
    /**
     * 获取订单状态
     */
    getOrderState(id) {
      const success = (data) => {
        this.status = 'success'
        this.$emit('success', data)
        this.close()
        this.clearTimer()
      }
      const fail = () => {
        this.status = 'fail'
        this.$emit('fail')
        this.close()
        this.clearTimer()
      }
      this.payLoadingModal()
      this.callNumber++
      if (this.callNumber > 20) {
        fail()
        this.payLoading.close()
        return
      }
      API.getOrderState(id).then(result => {
        const status = +result.data.status
        if (status !== 1) this.payLoading.close()
        if (status === 2) return success(result.data)
        if (status === -2 || status === -1) return fail()
        setTimeout(() => {
          this.getOrderState(id)
        }, 3000)
      }).catch(() => {
        fail()
      })
    },
    clearTimer() {
      this.callNumber = 0
      clearTimeout(this.timer)
      this.timer = null
    },
    payLoadingModal() {
      this.payLoading = this.$loading.service({
        lock: true,
        text: 'Payment Pending',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'el-loading-spinner-box'
      })
    }
  }
}
</script>
<style scoped  lang="scss">
.el-loading-spinner-box .el-loading-spinner{
  width: 420px;
  height: 155px;
  background: #fff;
  top: calc(50% - 77px);
  left: calc(50% - 210px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
.el-loading-spinner-box .el-icon-loading{
  font-size: 30px;
  margin-right: 16px;
}
</style>
<style>
/* 空中云汇  支付安全确认组件层级提升 */
#threeDs {
  z-index: 3000 !important;
}
</style>
